import React, { useState, useEffect, useRef } from "react";
import styles from "./index.module.css";
import Navbar from "../Builder/Navbar/Navbar.jsx";
import Modal from "../CommonV2/Modal/index.jsx";
import { useNavigate } from "react-router-dom";
import logoutHeader from "../../assets/logoutHeader.png";
import { useDispatch, useSelector } from "react-redux";
import { logout, updateUser, updateUserProperties } from "../../redux/slice/authSlice.js";
import { useImageUploader } from "../../customHooks/useImageUploader.js";
import Crop from "./cropper/CropperModal.jsx";
import DefaultImg from "./DefaultImg/index.jsx";
import uploadIcon from "../../assets/uploadIcon.png";
import tick from "../../assets/dashboard/tick.png";
import shopping from "../../assets/dashboard/shoppingBag.png";
import dropper from "../../assets/dashboard/dropper.png";
import bulb from "../../assets/dashboard/bulb.png";
import brush from "../../assets/dashboard/brush.png";
import weights from "../../assets/dashboard/weights.png";
import puzzel from "../../assets/dashboard/puzzel.png";
import backIcon from "../../assets/wall-icons/back_arrow.png";
import DropDown from "./DropDown";
import threeDotsIcon from "../../assets/menu.png";
import { message } from "antd";
import { postAPIData } from "../../Services/utils.js";
import { validateName, validateEmail, validatePhone, validateDob, validateGender } from "./utils.js";
import { addEvent } from "../../Services/mixpanel.js";
import { MixpanelEvents } from "../../constants/mixpanelEvents.js";

function Index() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const categories = [
        { icon: shopping, title: "Fashion & Lifestyle" },
        { icon: brush, title: "Home Decor" },
        { icon: bulb, title: "Tech & Gadgets" },
        { icon: weights, title: "Health & Fitness" },
        { icon: dropper, title: "Beauty & Personal Care" },
        { icon: puzzel, title: "Others" }
    ];

    const formatDateForInput = (date) => {
        // Check if date is valid
        if (!date || date === "") return "";
        // Return the date in YYYY-MM-DD format
        let [day, month, year] = date.split("/");
        return `${year}-${month}-${day}`;
    };
    const { user } = useSelector((state) => state.root.auth);
    const { handleUploadChange, loading, uploadRef } = useImageUploader();

    const [updateImageModalOpen, setUpdateImageModalOpen] = useState(false);
    const alignItems = "center";
    const [originalFormData, setOriginalFormData] = useState({
        fullName: user?.firstName || "",
        bio: user?.bio || "",
        dob: user?.dob ? formatDateForInput(user?.dob) || "" : "",
        email: user?.email || "",
        gender: user?.gender || "Not Selected",
        phone: user?.phoneNumber ? user.phoneNumber.replace(/^\+91/, "") : "",
        categories: user?.categories || []
    });
    const [formData, setFormData] = useState({ ...originalFormData });
    const [errors, setErrors] = useState({ fullName: null, email: null, phone: null });
    const [isButtonActive, setIsButtonActive] = useState(false);
    const [isVerifyVisible, setIsVerifyVisible] = useState(false);
    const [timer, setTimer] = useState(0);
    const [intervalId, setIntervalId] = useState(null);
    const [activeCategories, setActiveCategories] = useState(originalFormData.categories || []);
    const [menuVisible, setMenuVisible] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState("");
    const [isPhoneVerified, setIsPhoneVerified] = useState(true);
    const closeModalHandler = () => setShowModal(false);
    const menuRef = useRef(null);

    const isPhonevalid = formData.phone !== "" && /^[0-9]{10}$/.test(formData.phone);

    const handleBack = () => {
        history.back();
    };
    const handleCategoryClick = (title) => {
        setActiveCategories((prev) => {
            if (prev.includes(title)) {
                const updatedCategories = prev.filter((category) => category !== title);
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    categories: updatedCategories
                }));
                return updatedCategories;
            } else if (prev.length < 3) {
                const updatedCategories = [...prev, title];
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    categories: updatedCategories
                }));
                return updatedCategories;
            } else {
                return prev;
            }
        });
    };

    const isValidEmail = (email) => {
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailPattern.test(email);
    };
    const handleInputChange = (e) => {
        let { id, value } = e.target;
        let inputError = "";

        if (id === "bio") {
            value = value.replace(/(\r\n|\n|\r)/gm, "");
            e.target.value = value;
            e.target.style.height = "auto";
            e.target.style.height = `${e.target.scrollHeight - 26}px`;
        }

        if (id === "phone") {
            setOtpSent(() => false);
        }
        if (id === "fullName") {
            inputError = validateName(value);
        } else if (id === "email") {
            inputError = validateEmail(value);
        } else if (id === "phone") {
            inputError = validatePhone(value);
        } else if (id === "dob") {
            inputError = validateDob(value);
        }
        setFormData((prevData) => ({
            ...prevData,
            [id]: value
        }));
        setErrors((prevData) => ({
            ...prevData,
            [id]: inputError
        }));
    };

    const handleGenderChange = (gender) => {
        setFormData((prevData) => ({
            ...prevData,
            gender: gender
        }));
    };

    const validateInputs = () => {
        const newErrors = {};

        const nameError = validateName(formData.fullName);
        const emailError = validateEmail(formData.email);
        const phoneError = validatePhone(formData.phone);
        const dobError = validateDob(formData.dob);
        const genderError = validateGender(formData.gender);

        if (nameError) {
            newErrors.fullName = nameError;
        }
        if (emailError) {
            newErrors.email = emailError;
        }
        if (phoneError) {
            newErrors.phone = phoneError;
        }
        if (dobError) {
            newErrors.dob = dobError;
        }
        if (genderError) {
            newErrors.gender = genderError;
        }
        if (!formData.email && !formData.phone) {
            newErrors.phone = "Phone number or email is mandatory";
            newErrors.email = "Phone number or email is mandatory";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const sendOTP = async (e, phone) => {
        document.getElementById("phone").disabled = true;
        e.target.style.pointerEvents = "none";
        try {
            const response = await postAPIData(
                {
                    url: "auth/send/otp",
                    data: { phoneNumber: phone }
                },
                true
            );
            const { data } = response;

            if (data.message === "This phonenumber is linked with another account") {
                message.error("This phone number is linked with another account.");
            } else if (data === true) {
                message.success("OTP sent successfully.");
                setOtpSent(true);
                setTimer(30);
                setIntervalId(
                    setInterval(() => {
                        setTimer((prev) => prev - 1);
                    }, 1000)
                );
            } else if (data === "Too Many Attempts, Please try again later.") {
                message.error("Too many attempts. Please try again later.");
            } else {
                message.error(data.message);
            }
        } catch (error) {
            console.error(error);
            message.error("Failed to send OTP. Please try again.");
        }
        setTimeout(() => {
            message.destroy();
        }, 3000);

        e.target.style.pointerEvents = "auto";
        document.getElementById("phone").disabled = false;
    };

    const sendemail = async (e, email) => {
        e.target.style.pointerEvents = "none";
        try {
            const response = await postAPIData(
                {
                    url: "auth/send/verification_link",
                    data: { email: email }
                },
                true
            );
            const { data } = response;

            if (data.message === "This email is linked with another account") {
                message.error("This email is linked with another account.");
            } else if (data.message === "email sent") {
                message.success("Verification email sent successfully.");
                const updatedUser = { ...user };
                updatedUser.email = email;
                updatedUser.emailVerified = false;
                dispatch(updateUser(updatedUser));
                setFormData((prevData) => ({
                    ...prevData,
                    email: email,
                    emailVerified: false
                }));
            } else if (data.message === "TOO_MANY_EMAIL_ATTEMPTS") {
                message.error("Too many attempts. Please try again later.");
            } else {
                message.error("An unexpected error occurred.");
            }
        } catch (error) {
            if (error.response && error.response.status === 429) {
                message.error("Too many email requests. Please try again later.");
            } else {
                console.error(error);
                message.error("Failed to send verification email. Please try again.");
            }
        }
        e.target.style.pointerEvents = "auto";
    };

    const handleOtpChange = (e) => {
        const { value } = e.target;
        setOtp(value);
        if (value.length === 6) {
            verifyOTP(value);
        }
    };

    const verifyOTP = async (otp) => {
        try {
            const response = await postAPIData(
                {
                    url: "auth/verify/otp",
                    data: {
                        phoneNumber: formData.phone,
                        otp: otp
                    }
                },
                true
            );
            if (response.data) {
                if (response.data._id === user._id) {
                    message.success("OTP verified successfully.");
                    setOtpSent(false);
                    setIsPhoneVerified(true);
                    dispatch(updateUserProperties({ phoneNumber: response.data.phoneNumber }));
                    setOriginalFormData({
                        ...formData,
                        categories: formData.categories,
                        phoneNumber: response.data.phoneNumber
                    });
                    setIsButtonActive(false);
                } else {
                    message.error("User ID mismatch.");
                }
            } else {
                message.error("Invalid OTP.");
            }
        } catch (error) {
            console.error(error);
            message.error("Failed to verify OTP.");
        } finally {
            clearInterval(intervalId);
        }
    };

    const handleSaveDetails = async (e) => {
        e.target.disabled = true;
        if (validateInputs()) {
            if (!isPhoneVerified) {
                message.error("Please verify your phone number before updating.");
                return;
            }

            const formatDate = (date) => {
                const d = new Date(date);
                const month = `0${d.getMonth() + 1}`.slice(-2); // Months are zero-based
                const day = `0${d.getDate()}`.slice(-2);
                const year = d.getFullYear();
                return `${day}/${month}/${year}`;
            };
            const dobString = formData.dob ? formatDate(formData.dob) : "";

            const obj = {
                firstName: formData.fullName,
                bio: formData.bio,
                dob: dobString,
                gender: formData.gender,
                phoneNumber: isPhoneVerified ? (formData.phone ? `+91${formData.phone}` : "") : user.phone,
                category: formData.categories || []
            };
            try {
                const userData = await postAPIData(
                    {
                        url: "api/user/update_user",
                        data: obj
                    },
                    true
                );
                if (userData.data) {
                    const updatedUser = { ...userData.data.user };
                    dispatch(updateUser(updatedUser));
                    message.success("Details updated successfully.");
                    setOriginalFormData({
                        ...formData,
                        categories: formData.categories
                    });
                    setIsButtonActive(false);
                } else {
                    message.error("Failed to update details.");
                }
            } catch (error) {
                console.error(error);
                message.error("Failed to update details. Please try again.");
            }
        }
        e.target.disabled = false;
    };
    useEffect(() => {
        const ele = document.getElementById("bio");
        ele.style.height = "auto";
        ele.style.height = `${ele.scrollHeight - 26}px`;
        addEvent({}, MixpanelEvents.LOADED_PROFILE_PAGE);
    }, []);
    useEffect(() => {
        if (
            formData.fullName !== originalFormData.fullName ||
            formData.bio !== originalFormData.bio ||
            formData.dob !== originalFormData.dob ||
            formData.gender !== originalFormData.gender ||
            // formData.phone !== originalFormData.phone ||
            JSON.stringify(formData.categories) !== JSON.stringify(originalFormData.categories)
        ) {
            setIsButtonActive(true);
        } else {
            setIsButtonActive(false);
        }
    }, [formData, originalFormData]);

    useEffect(() => {
        if (timer === 0) {
            clearInterval(intervalId);
            document.getElementById("phone").disabled = false;
        }
    }, [timer, intervalId]);

    useEffect(() => {
        if (menuVisible) {
            const handleOutsideClick = (e) => {
                if (menuRef.current && !menuRef.current.contains(e.target)) {
                    setMenuVisible(false);
                }
            };

            document.addEventListener("mousedown", handleOutsideClick);
            return () => {
                document.removeEventListener("mousedown", handleOutsideClick);
            };
        }
    }, [menuVisible]);

    return (
        <div className={styles.container}>
            <div className={styles.navbarContainer}>
                <div className={styles.topDiv}></div>
                <Navbar analytics={true} currPage={"profile"} />
            </div>
            <div className={styles.wrapper}>
                <div className={styles.headingContainer}>
                    <div className={styles.heading}>
                        <img src={backIcon} className={styles.backButton} onClick={handleBack} />
                        <span className={`${styles.headingText} ${styles.webHeading}`}>Account Settings</span>
                        <span className={`${styles.headingText} ${styles.mobileHeading}`}>Profile Settings</span>
                        <img src={threeDotsIcon} alt="menu" className={styles.menuIcon} onClick={() => setMenuVisible((prev) => !prev)} />
                        {menuVisible && (
                            <div className={styles.menu} ref={menuRef}>
                                <button onClick={() => setShowModal(true)}>Logout</button>
                            </div>
                        )}
                    </div>
                    <div className={styles.line}></div>
                </div>

                <div className={styles.subcontainer1}>
                    <div>
                        {user && user.profileImg ? (
                            <img src={user.profileImg} alt="profile" className={styles.profileImage} />
                        ) : (
                            <div className="profile-img">
                                <DefaultImg height={"80px"} width={"80px"} radius={"40px"} fontSize={"2.5em"} fullName={user.firstName} />
                            </div>
                        )}
                        <img src={uploadIcon} alt="icon" className={styles.uploadIcon} onClick={() => setUpdateImageModalOpen(true)} />
                        <div className={styles.profileDetails}>
                            <p className={styles.firstName}>{user?.firstName}</p>
                            <p className={styles.userName}>@{user?.userName}</p>
                        </div>
                    </div>

                    <div className={styles.saveButtonWrapper}>
                        <button
                            className={`${styles.saveButton} ${isButtonActive ? styles.active : styles.inactive}`}
                            onClick={handleSaveDetails}
                            disabled={!isButtonActive}
                        >
                            Save Details
                        </button>
                    </div>
                </div>

                <div className={styles.inputContainer}>
                    <div className={styles.row}>
                        <div className={styles.inputGroup}>
                            <label htmlFor="fullName">Full Name</label>
                            <input
                                type="text"
                                id="fullName"
                                value={formData.fullName}
                                maxLength="30"
                                onChange={handleInputChange}
                                className={errors.fullName ? styles.errorInput : ""}
                            />
                            {errors.fullName && <p className={styles.errorMessage}>{errors.fullName}</p>}
                        </div>

                        <div className={`${styles.inputGroup} ${styles.bioInputGroup}`}>
                            <label htmlFor="fullName">Bio</label>
                            <textarea
                                id="bio"
                                value={formData.bio}
                                maxLength="75"
                                rows={1}
                                onChange={handleInputChange}
                                className={`${styles.bioInput} ${errors.bio ? styles.errorInput : ""}`}
                            ></textarea>
                            {<p className={styles.bioLimit}>{formData.bio.length + "/75"}</p>}
                        </div>

                        <div className={styles.inputGroup}>
                            <label htmlFor="gender">Gender</label>
                            <DropDown setGender={handleGenderChange} gender={formData.gender} />
                            {errors.gender && <p className={styles.errorMessage}>{errors.gender}</p>}
                        </div>
                    </div>

                    <div className={styles.row}>
                        <div className={styles.inputGroup}>
                            <label htmlFor="dob">Date of Birth</label>
                            <input
                                type="date"
                                id="dob"
                                min="1947-01-01"
                                max="2012-12-31"
                                value={formData.dob}
                                onChange={handleInputChange}
                            />
                            {errors.dob && <p className={styles.errorMessage}>{errors.dob}</p>}
                        </div>
                        <div className={styles.inputGroup}>
                            <label htmlFor="username">Username</label>
                            <input type="text" id="username" value={`faym.co/i/${user?.userName || ""}`} disabled />
                        </div>
                    </div>

                    <div className={styles.row}>
                        <div className={styles.inputGroup}>
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                value={formData.email}
                                onChange={handleInputChange}
                                className={errors.email ? styles.errorInput : ""}
                            />
                            {formData.email === user.email ? (
                                user.emailVerified ? (
                                    <img src={tick} alt="verified" className={styles.tickIcon} />
                                ) : (
                                    <p className={styles.pendingText}>Pending</p>
                                )
                            ) : (
                                isValidEmail(formData.email) &&
                                user.email !== formData.email && (
                                    <div onClick={(e) => sendemail(e, formData.email)} className={styles.verifyButton}>
                                        Verify
                                    </div>
                                )
                            )}
                            {errors.email && <p className={styles.errorMessage}>{errors.email}</p>}
                        </div>
                        <div className={styles.inputGroup}>
                            <label htmlFor="phone">Phone Number</label>
                            <input
                                type="tel"
                                id="phone"
                                minLength={10}
                                maxLength={10}
                                value={formData.phone}
                                onChange={handleInputChange}
                                className={errors.phone ? styles.errorInput : ""}
                            />
                            {formData.phone === "" ? null : formData.phone === originalFormData.phone ? (
                                <img src={tick} alt="verified" className={styles.tickIcon} />
                            ) : otpSent ? (
                                <p className={styles.pendingText}>Pending</p>
                            ) : (
                                isPhonevalid && (
                                    <div
                                        onClick={(e) => {
                                            sendOTP(e, formData.phone);
                                        }}
                                        className={styles.verifyButton}
                                    >
                                        Verify
                                    </div>
                                )
                            )}
                            {errors.phone && <p className={styles.errorMessage}>{errors.phone}</p>}
                            {otpSent && timer > 0 ? (
                                <p className={styles.timer}>Request OTP in 00:{timer < 10 ? `0${timer}` : timer}</p>
                            ) : otpSent && timer == 0 ? (
                                <p className={styles.timer}>
                                    Didn't receive OTP? <span onClick={(e) => sendOTP(e, formData.phone)}>Resend OTP</span>
                                </p>
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>

                    {otpSent ? (
                        <div className={`${styles.row} ${styles.otpRow}`} style={{ flexDirection: "row-reverse" }}>
                            <div className={styles.inputGroup}>
                                <label htmlFor="OTP">Enter OTP</label>
                                <input
                                    type="text"
                                    id="otp"
                                    minLength={6}
                                    maxLength={6}
                                    value={otp}
                                    onChange={handleOtpChange}
                                    className={errors.otp ? styles.errorInput : ""}
                                />
                                {errors.otp && <p className={styles.errorMessage}>Invalid Otp</p>}
                            </div>
                        </div>
                    ) : null}
                </div>

                <div className={styles.categories}>
                    <p className={styles.categoriesHeading}> Categories ({activeCategories.length}/3)</p>
                    <div className={styles.allcategories}>
                        {categories.map((category, index) => (
                            <div
                                key={index}
                                className={`${styles.categoryItem} ${
                                    activeCategories.includes(category.title) ? styles.activeCategory : ""
                                }`}
                                onClick={() => handleCategoryClick(category.title)}
                            >
                                <img src={category.icon} alt={`${category.title} icon`} className={styles.categoryIcon} />
                                <p className={styles.categoryTitle}>{category.title}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <Modal
                showModal={updateImageModalOpen}
                setShowModal={setUpdateImageModalOpen}
                onClose={() => setUpdateImageModalOpen(false)}
                alignItems={alignItems}
            >
                <Crop uploadImage={handleUploadChange} closeModal={() => setUpdateImageModalOpen(false)} uploadRef={uploadRef} />
            </Modal>

            <Modal showModal={showModal} setShowModal={setShowModal} onClose={closeModalHandler} alignItems={alignItems}>
                <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                    <div className={styles.headerImage} style={{ backgroundImage: `url(${logoutHeader})` }}></div>
                    <div className={styles.message}>
                        Are you sure, <br />
                        you want to logout?
                    </div>
                    <div className={styles.buttonContainer}>
                        <button className={styles.cancelButton} onClick={closeModalHandler}>
                            Cancel
                        </button>
                        <button
                            className={styles.logoutButton}
                            onClick={() => {
                                localStorage.removeItem("IdToken");
                                localStorage.removeItem("userName");
                                localStorage.clear();
                                dispatch(logout());
                                navigate("/");
                                addEvent({}, MixpanelEvents.LOGOUT_CLICKED);
                            }}
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default Index;
